import { useEffect } from "react"
import { App as CapacitorApp } from "@capacitor/app"
import { Capacitor } from "@capacitor/core"

// Handles the Android hardware/gesture back button: navigate within the app's
// history instead of letting Capacitor fall back to its default behavior of
// closing the app.
const BackButtonHandler = () => {
    useEffect(() => {
        if (Capacitor.getPlatform() !== "android") {
            return
        }

        const listenerPromise = CapacitorApp.addListener("backButton", ({ canGoBack }) => {
            // At the root of the navigation stack: do nothing instead of
            // minimizing or exiting the app.
            if (canGoBack) {
                window.history.back()
            }
        })

        return () => {
            listenerPromise.then((listener) => listener.remove())
        }
    }, [])

    return null
}

export default BackButtonHandler
